<template>
    <form ref="form" action="/search" method="GET" class="mt-2 lg:m-1 hidden sm:block">
        <vue-autosuggest
            @selected="onSelected"
            v-model="query"
            :suggestions="filteredOptions"
            :input-props="{
                id: 'search-input',
                name: 'query',
                type: 'search',
                class: 'form-control sm:w-48 lg:w-64 ml-1 rounded-full border-2',
                placeholder: 'Search for products, stores, or categories'
            }"
        >
            <template slot-scope="{ suggestion }">
                {{ suggestion.item }}
            </template>
        </vue-autosuggest>
    </form>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest';

export default {
    components: {
        VueAutosuggest
    },

    props: {
        query: {
            type: String,
            default: ''
        }
    },

    data: () => ({
        suggestions: [{
            data: {}
            // data: window.App.categories || {}
        }]
    }),

    created() {
        if (this.app && this.app.categories) {
            this.suggestions = [{
                data: this.app.categories || {}
            }];
        }
    },

    mounted() {},

    computed: {
        filteredOptions() {
            if (
                this.query === null
             || this.query === ''
             || this.query.length < 3
            ) {
                return [{data: []}];
            }

            return [{
                data: this.suggestions[0].data.filter(option => {
                    return option.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
                })
            }];
        }
    },

    methods: {
        // clickHandler(item) {},
        // onInputChange(text) {},

        onSelected(item) {
            this.query = item.item;

            this.$nextTick(() => {
                this.$refs.form.submit();
            });
        }
    }
}
</script>

<style lang="scss">
// <style lang="scss" scoped>
#search-input {
    border-color: #7cb2fe;
}

#autosuggest {
    // @apply relative;
}

.autosuggest__results-item--highlighted {
    background-color: rgba(51, 217, 178, 0.1);
}

.autosuggest-container {
    // @apply flex justify-center;
    width: 280px;
}

.autosuggest__results-container {
    position: absolute;
    width: 100%;

    ul {
        font-size: 13px;
        border-radius: 4px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border: 1px solid rgba(72, 94, 144, 0.16);
        background-color: #fff;
        width: 100%;
        color: rgba(30, 39, 46,1.0);
        list-style: none;
        margin: 0;
        margin-top: 8px;
        padding: 0.5rem 0 .5rem 0;
    }

    li {
        margin: 0;
        padding: 4px 10px;
        display: flex;
        align-items: center;
        color: #1b2e4b;

        &:hover {
            cursor: pointer;
            color: #0168fa;
        }
    }
}
</style>
